import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
let config;

if (Object.keys(serverRuntimeConfig).length === 0 && serverRuntimeConfig.constructor === Object) {
	config = publicRuntimeConfig;
	for (let key in config) {
		if (config.hasOwnProperty(key)) {
			config[key] = config[key].replace('localhost', window.location.hostname);
		}
	}
} else {
	config = serverRuntimeConfig;
}

config.availableLanguages = ['en', 'fr', 'es', 'ru'];

export default config;
